module.exports = __webpack_public_path__ + "static/media/1POLICY48.93fd8f7d.jpg";